/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 金額単位
 */
export type EucAmountUnit = (typeof EucAmountUnit)[keyof typeof EucAmountUnit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EucAmountUnit = {
  円: '円',
  千円: '千円',
} as const;
